<template>
  <b-form-group>
    <legend class="col-form-label p-0" slot="label">
      Kolor
      <div class="color" :style="{ 'background-color': color.hex8 }"></div>
    </legend>
    <b-input class="color-picker-input" v-model="color.hex8"></b-input>
    <chrome-picker class="color-picker" v-model="color" @input="updateValue"></chrome-picker>
  </b-form-group>
</template>
<script>
import { Chrome } from 'vue-color';
const color = '#ffffffff';
export default {
  components: { 'chrome-picker': Chrome },
  data() {
    return {
      color
    };
  },
  methods: {
    updateValue(value) {
      this.$emit('picked', value.hex8);
    }
  }
};
</script>
<style>
.color-picker {
  position: absolute;
  display: none;
}
.color-picker-input:focus + .color-picker,
.color-picker:hover {
  display: block;
  z-index: 1;
}
.color {
  display: inline-block;
  height: 14px !important;
  width: 14px !important;
  border: 1px solid lightgrey;
  border-radius: 100%;
}
</style>
